import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PageHeader from "@/components/common/PageHeader";
import StatusBadge from "@/components/common/StatusBadge";

export default function ImportHistory() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/uploads"); setRows(data); } catch {}
      setLoading(false);
    })();
  }, []);

  return (
    <div className="p-6 md:p-8 max-w-[1600px] mx-auto">
      <PageHeader title="Import History" subtitle="Every broker report processed into the campaign." breadcrumbs="Imports" testId="imports-page" />
      <div className="bg-[#111827] border border-white/10 rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-white/10 bg-[#1F2937]/50 text-left text-[10px] uppercase tracking-widest text-gray-500">
                <th className="px-4 py-3">File</th>
                <th className="px-4 py-3">Uploaded by</th>
                <th className="px-4 py-3">Uploaded at</th>
                <th className="px-4 py-3">Status</th>
                <th className="px-4 py-3 text-right">Rows</th>
                <th className="px-4 py-3 text-right">Matched</th>
                <th className="px-4 py-3 text-right">Unmatched</th>
                <th className="px-4 py-3 text-right">Duplicate</th>
                <th className="px-4 py-3 text-right">Invalid</th>
                <th className="px-4 py-3 text-right">Valid Lot</th>
              </tr>
            </thead>
            <tbody>
              {loading ? <tr><td colSpan={10} className="p-8 text-center text-gray-500">Loading…</td></tr> :
                rows.length === 0 ? <tr><td colSpan={10} className="p-8 text-center text-gray-500">No imports yet</td></tr> :
                rows.map((u) => (
                  <tr key={u.id} data-testid={`import-row-${u.id}`} className="border-b border-white/5 hover:bg-white/[0.02]">
                    <td className="px-4 py-3">
                      <p className="text-white font-medium">{u.file_name}</p>
                      <p className="text-[10px] font-mono text-gray-500 uppercase">{u.file_type}</p>
                    </td>
                    <td className="px-4 py-3 text-gray-300">{u.uploaded_by_name || u.uploaded_by}</td>
                    <td className="px-4 py-3 text-xs font-mono text-gray-400">{(u.uploaded_at || "").slice(0, 16).replace("T", " ")}</td>
                    <td className="px-4 py-3"><StatusBadge status={u.import_status === "completed" ? "approved" : u.import_status === "pending_mapping" ? "pending" : u.import_status} /></td>
                    <td className="px-4 py-3 text-right font-mono">{u.total_rows}</td>
                    <td className="px-4 py-3 text-right font-mono text-emerald-400">{u.matched_rows}</td>
                    <td className="px-4 py-3 text-right font-mono text-gray-400">{u.unmatched_rows}</td>
                    <td className="px-4 py-3 text-right font-mono text-gray-400">{u.duplicate_rows}</td>
                    <td className="px-4 py-3 text-right font-mono text-red-400">{u.invalid_rows}</td>
                    <td className="px-4 py-3 text-right font-mono text-blue-300">{(u.total_valid_lot_imported || 0).toFixed(2)}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
